import axios from "axios";

export const PORTAL_API = `${process.env.REACT_APP_BACKEND_URL}/api/portal`;
export const PORTAL_TOKEN_KEY = "bg_portal_token";

export const portalApi = axios.create({ baseURL: PORTAL_API });

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(PORTAL_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// images and documents load through <img>/<a>, so a short-lived asset token rides in the query
const PORTAL_ASSET_KEY = "bg_portal_asset_token";
let portalAssetTimer = null;
export async function ensurePortalAssetToken() {
  if (!localStorage.getItem(PORTAL_TOKEN_KEY)) return "";
  try {
    const { data } = await portalApi.get("/asset-token");
    if (data?.token) localStorage.setItem(PORTAL_ASSET_KEY, data.token);
    if (!portalAssetTimer)
      portalAssetTimer = setInterval(() => ensurePortalAssetToken(), 20 * 60 * 1000);
  } catch {
    /* keep the previous token */
  }
  return localStorage.getItem(PORTAL_ASSET_KEY) || "";
}
export const getPortalAssetToken = () => localStorage.getItem(PORTAL_ASSET_KEY) || "";

export const portalAsset = (path) => {
  const t = getPortalAssetToken();
  if (!t) ensurePortalAssetToken();
  return `${PORTAL_API}${path}${path.includes("?") ? "&" : "?"}pt=${t}`;
};

export const portalMoney = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

export const portalDate = (iso) =>
  iso
    ? new Date(iso).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      })
    : "";

// SEO-friendly slugs like "aqua-bleu-slab-<id>"; the id is the trailing 24-hex.
export const slugify = (s) =>
  String(s || "")
    .toLowerCase()
    .replace(/[™®]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "item";

export const itemSlug = (kind, name, id) =>
  `${slugify(name)}-${kind === "Remnant" ? "remnant" : "slab"}-${id}`;

export const sinkSlug = (name, id) => `${slugify(name)}-sink-${id}`;

export const idFromSlug = (slug) => {
  const m = String(slug || "").match(/[0-9a-fA-F]{24}/g);
  return m ? m[m.length - 1] : String(slug || "");
};

// Warm the portal asset token on load so <img>/<a> URLs have one ready for the first paint.
if (typeof window !== "undefined" && localStorage.getItem(PORTAL_TOKEN_KEY)) {
  ensurePortalAssetToken();
}
